import type { QueryClient } from '@tanstack/react-query';

/**
 * Refreshes connection evidence after setup changes or failed sends.
 * @param queryClient - Cache used by the initiating operation.
 * @param tenantId - Optional tenant scope; omission refreshes all cached tenants.
 */
export const refreshWhatsAppAvailability = (
  queryClient: QueryClient,
  tenantId?: string | null
): void => {
  const scope = tenantId === undefined ? [] : [tenantId];
  for (const prefix of [
    'messaging/sender-availability',
    'messaging/whatsapp/phones',
    'messaging/whatsapp/integrations',
  ]) {
    void queryClient.invalidateQueries({ queryKey: [prefix, ...scope] });
  }
};
